import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import swal from 'sweetalert'
import VueResource from 'vue-resource';

moment.locale('es');

Vue.use(VueResource);

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});

Date.prototype.toDateInputValue = (function() {
    var local = new Date(this);
    local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
    return local.toJSON().slice(0,10);
});

Date.prototype.toDateInputValue_Mes_Siguiente = (function() {
    var local = new Date(this);
    local.setMonth(local.getMonth() + 1);
    local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
    return local.toJSON().slice(0,10);
});

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}



// WEBPACK FOOTER //
// ./src/main.js